import { useContext, useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import SuperTokens from "supertokens-auth-react";
import { useStiggContext } from "@stigg/react-sdk";
import { AuthContext } from "../providers/Auth";
import { superTokensConfig } from "../settings/supertokens";
import { checkIsEmailVerified } from "../utils/verification";
import AnonymousRoutes from "./AnonymousRoutes";
import ApplicationRoutes from "./ApplicationRoutes";
import InvalidUserRoutes from "./InvalidUserRoutes";
import { SessionAuth, useSessionContext } from "supertokens-auth-react/recipe/session";
import { signOut } from "supertokens-auth-react/recipe/thirdpartyemailpassword";

SuperTokens.init(superTokensConfig);

export default function AppRoutes() {
  const sessionContext = useSessionContext() as any;
  const { doesSessionExist, invalidClaims, loading, accessTokenPayload } = sessionContext;
  const isEmailVerified = checkIsEmailVerified(doesSessionExist, invalidClaims);
  const { setAuthConfig } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isLoadingStigg, setIsLoadingStigg] = useState(true);
  const { stigg } = useStiggContext();
  const { hasAccess: hasPipelinesAccess, isFallback } = stigg.getBooleanEntitlement({ featureId: "feature-pipelines" });

  useEffect(() => {
    if (!isFallback) {
      setIsLoadingStigg(false);
    }
  }, [hasPipelinesAccess, isFallback]);

  async function onLogout() {
    await signOut();
    if ("posthog" in window) {
      (window["posthog"] as any).reset();
    }
    // if ("$chatwoot" in window) {
    //   (window["$chatwoot"] as any).reset();
    // }
    navigate("/");
  }

  useEffect(() => {
    if (setAuthConfig)
      setAuthConfig({
        sessionExists: doesSessionExist,
        verified: isEmailVerified,
        showProfile: true,
        signOut: onLogout,
        accessTokenPayload: accessTokenPayload,
      });
  }, [doesSessionExist, isEmailVerified]);

  if (loading) {
    return null;
  }

  if (!doesSessionExist) {
    return (
      <Routes>
        <Route path="*" element={<AnonymousRoutes />} />
      </Routes>
    );
  }

  if (!isEmailVerified) {
    return (
      <Routes>
        <Route path="*" element={<InvalidUserRoutes />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        path="*"
        element={
          <SessionAuth>{!isLoadingStigg && hasPipelinesAccess !== null && <ApplicationRoutes hasPipelinesAccess={hasPipelinesAccess} />}</SessionAuth>
        }
      />
    </Routes>
  );
}
